import { menuItems, SideMenuChildren } from '@components/sidebar/menuList'

export function GetMenuColorCode(path: string) {
  for (let i = 0; i < menuItems.length; i++) {
    const menuItem = menuItems[i]
    for (let j = 0; j < menuItem.children.length; j++) {
      const child = menuItem.children[j]
      if (child.urlPattern && path.includes(child.urlPattern)) {
        return child.colorCode
      }
    }
  }
}

export function GetMenuTitle(path: string) {
  for (let i = 0; i < menuItems.length; i++) {
    const menuItem = menuItems[i]
    for (let j = 0; j < menuItem.children.length; j++) {
      const child = menuItem.children[j]
      if (child.urlPattern && path.includes(child.urlPattern)) {
        return child.title
      }
    }
  }
}

export function GetMenuSubtitle(path: string) {
  for (let i = 0; i < menuItems.length; i++) {
    const menuItem = menuItems[i]
    for (let j = 0; j < menuItem.children.length; j++) {
      const child = menuItem.children[j]
      if (child.urlPattern && path.includes(child.urlPattern)) {
        return menuItem.caption
      }
    }
  }
}

export function GetMenuMetaData(path: string) {
  for (let i = 0; i < menuItems.length; i++) {
    const menuItem = menuItems[i]
    for (let j = 0; j < menuItem.children.length; j++) {
      const child = menuItem.children[j]
      if (child.urlPattern && path.includes(child.urlPattern)) {
        return {
          title: child.title,
          subtitle: menuItem.title + ' - ' + menuItem.caption,
          colorCode: child.colorCode,
        }
      }
    }
  }
}

export function GetMenuChildParentTitle(child: SideMenuChildren) {
  for (let i = 0; i < menuItems.length; i++) {
    const menuItem = menuItems[i]
    for (let j = 0; j < menuItem.children.length; j++) {
      const menuChild = menuItem.children[j]
      if (menuChild.children) {
        for (let k = 0; k < menuChild.children.length; k++) {
          const menuSubChild = menuChild.children[k]
          if (menuSubChild.id === child.id) {
            return menuChild.title
          }
        }
      }
    }
  }
}
